import { create } from 'zustand';

type State = {
  loading: boolean;
  mensagem?: string;
};

type Action = {
  setLoading: (loading: boolean, mensagem?: string) => void;
  stopLoading: () => void;
};

const useLoadingStore = create<State & Action>((set) => ({
  loading: false,
  mensagem: undefined,
  setLoading: (loading: boolean, mensagem?: string) =>
    set({ loading: loading, mensagem: mensagem }),
  stopLoading: () => set({ loading: false, mensagem: undefined }),
}));

export default useLoadingStore;
